import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { ProFormaInvoice, CreateProFormaInvoiceRequest, ProFormaStatus } from '../types';

export const proFormaInvoiceService = {
  getAll: async (): Promise<ProFormaInvoice[]> => {
    const response = await apiClient.get<ProFormaInvoice[]>(
      API_ENDPOINTS.PROFORMA_INVOICES.BASE
    );
    return response.data;
  },

  getById: async (id: number): Promise<ProFormaInvoice> => {
    const response = await apiClient.get<ProFormaInvoice>(
      API_ENDPOINTS.PROFORMA_INVOICES.BY_ID(id)
    );
    return response.data;
  },

  getByStatus: async (status: ProFormaStatus): Promise<ProFormaInvoice[]> => {
    const response = await apiClient.get<ProFormaInvoice[]>(
      API_ENDPOINTS.PROFORMA_INVOICES.BY_STATUS(status)
    );
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string): Promise<ProFormaInvoice[]> => {
    const response = await apiClient.get<ProFormaInvoice[]>(
      API_ENDPOINTS.PROFORMA_INVOICES.DATE_RANGE,
      { params: { startDate, endDate } }
    );
    return response.data;
  },

  create: async (data: CreateProFormaInvoiceRequest): Promise<ProFormaInvoice> => {
    const response = await apiClient.post<ProFormaInvoice>(
      API_ENDPOINTS.PROFORMA_INVOICES.BASE,
      data
    );
    return response.data;
  },

  issue: async (id: number): Promise<ProFormaInvoice> => {
    const response = await apiClient.post<ProFormaInvoice>(
      API_ENDPOINTS.PROFORMA_INVOICES.ISSUE(id)
    );
    return response.data;
  },
};
